
import React, { useState, useEffect } from 'react'
import { Tree } from 'antd'
import { fromJS } from 'immutable'
import { http } from '@ud/admin-framework'
import _ from 'lodash'

const { TreeNode } = Tree

let data: any = []

const FilterDepartmentTree: React.FC<IFilterDepartmentTreeProps> = (props) => {
  const [treeShow, setTreeShow] = useState<any[]>([])
  const [treeData, setTreeData] = useState<any[]>([])
  const [peersTreeData, setPeersTreeData] = useState<any[]>([])
  const [expandedKeys, setExpandedKeys] = useState<string[]>([])
  const [selectedNodeKeys, setSelectedKeys] = useState<string[]>([])
  const [autoExpandParent, setAutoExpandParent] = useState<boolean>(true)

  const treeSerializationFn = (tree: any) => {
    if (!tree) {
      return
    }
    if (tree.children && tree.children.length) {
      return {
        title: tree.name,
        key: tree.uid,
        children: tree.children.map((item: any) => {
          return treeSerializationFn(item)
        })
      }
    } else {
      return {
        title: tree.name, key: tree.uid, children: tree.children
      }
    }
  }
 
  const getTreeData = () => {
    http.get('/manage/org/query/orgUnitTree', { params: { dimensionCode: 'DEFAULT' } }).then((res) => {
      let tree: any = treeSerializationFn(res.data)
      setPeersData([tree])
      setTreeData([res.data])
      data = [tree]
      const searchValue = props.currentUserDepartment
      if (searchValue && searchValue.directUnitName) {
        filterTreeData(searchValue.directUnitName)
      }
    })
  }

  const setPeersData = (tree: any, keys?: any) => {
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];
      const key: string = node.key;
      const title: string = node.title;
      const keysT: any = []
      keysT.push(key)
      if (keys) {
        keysT.push(...keys)
      }
      peersTreeData.push({ key, title, keys: keysT })

      setPeersTreeData(peersTreeData)
      if (node.children) {
        setPeersData(node.children, keysT);
      }
    }
  }

  const screenFn = (dataTree: any, ids: string[]) => {
    if (!(dataTree && dataTree.length)) { return }
    let dt = dataTree.filter((item: any) => ids.filter(itemT => itemT === item.key).length)
    if (dt.length) {
      return dt.map((item: any) => {

        item.children = screenFn(item.children, ids)
        return item
      })
    }
  }

  const filterTreeData = (val: string) => {
    let tree: any[] = []
    let ids: string[] = []

    // const node: any = peersTreeData.map((item: any) => {
    //   if (item.title.indexOf(val) > -1) {
    //     return item;
    //   }
    //   return null;
    // }).filter((item: any, i: any, self: any) => item && self.indexOf(item) === i)

    let treeS = peersTreeData.filter((item: any) => item.title.indexOf(val) > -1)

    for (let i of treeS) {
      ids.push(...i.keys)
    }
    ids = _.uniq(ids)

    if (ids.length > 0) {
      tree = screenFn(fromJS(data).toJS(), ids)
      console.log('筛选后的数据', tree)
      const node = renderTreeNode(tree)
      if (node) {
        setTreeShow(node)
      }
    }
    setExpandedKeys(ids)
  }

  const getParentKey = (key: string, tree: any): void => {
    let parentKey;
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];
      if (node.keys) {

        if (node.keys.some((item: any) => item.key === key)) {

          parentKey = node.key;
        } else if (getParentKey(key, node.keys) as any) {
          parentKey = getParentKey(key, node.keys);
        }
      }
    }
    return parentKey;
  }

  const onExpand = (expandedKeys: any[]) => {
    setExpandedKeys(expandedKeys)
    setAutoExpandParent(false)
  }

  const selectNode = (selectedKeys: any[], e: any) => {
    if (selectedKeys.length > 0) {
      setSelectedKeys(selectedKeys)
      props.selectTreeNode && props.selectTreeNode(selectedKeys[0], e.selectedNodes[0].props)
    }
  }

  const renderTreeNode = (nodes: any[]) => {
    return nodes.map((v: any, i: number) => {
      if (v.children) {
        return (
          <TreeNode key={v.key} title={v.title}>
            {renderTreeNode(v.children)}
          </TreeNode >
        );
      }
      return <TreeNode key={v.key} title={v.title} />;
    })
  }

  useEffect(() => {
    getTreeData()
  }, [props.currentUserDepartment])

  return (
    <Tree
      onExpand={onExpand}
      expandedKeys={expandedKeys}
      selectedKeys={selectedNodeKeys}
      autoExpandParent={autoExpandParent}
      onSelect={selectNode}
    >
      {treeShow}
    </Tree>
  )
}

interface IFilterDepartmentTreeProps {
  nodes?: any
  selectTreeNode?: any
  currentUserDepartment?: any
}

export default FilterDepartmentTree